module.exports = __webpack_public_path__ + "img/Sukiya.e2d8a0cd.svg";